/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import ShutterStock from 'material/embeds/imageapi/imagepane/pane/images/shutterstock/shutterstock_container';
import Unsplash from 'material/embeds/imageapi/imagepane/pane/images/unsplash/unsplash_container';
import ImageTypes from 'material/embeds/imageapi/controller/imagetypes/imagetypes';
import Field from 'material/form/field/field_container';
import ImagePane from 'material/embeds/imageapi/imagepane/imagepane';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/images/image_toggle_styles';


/* ========== ~~~~~~~~~~ IMAGE TABS : IMAGES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ImageToggle extends Component {
	constructor(props) {
		super(props)
	};

	handleChange = (e) => this.props.imageTabSelect(e.target.value);

	render() {
		return (
			<div className={`image_toggle ${this.props.classes.image_toggle}`} >
				<div className={`controls ${this.props.classes.controls}`}>
					<div className={`innerControls`}>
						{/* wide view */}
						<ImageTypes selectAction={this.props.imageTabSelect} selected={this.props.imageTab} options={[
							{ name: 'unsplash', text: 'Unsplash' },
							{ name: 'shutterstock', text: 'Shutterstock' },
						]} />

						{/* thinner view */}
						<Field type={`select`} name={`imagetype`} defaultValue={this.props.imageTab} handleChange={this.handleChange} options={[
							{ name: 'unsplash', value: 'unsplash', text: 'Unsplash' },
							{ name: 'shutterstock', value: 'shutterstock', text: 'Shutterstock' },
						]} />
					</div>
				</div>
			</div>			
		)
	};
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageToggle);
